import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const UndoButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    className: "p-left-6",
    onClick: onClick,
    use: "link-on-bright",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.alerts.undo-button"
    })
  });
};
UndoButton.displayName = 'UndoButton';
UndoButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default UndoButton;